import React from 'react';

import RatePresenter from '../../../../../../../../../../presenters/RatePresenter';
import DatePresenter from '../../../../../../../../../../presenters/DatePresenter';

const RateCell = ({ rate }) => {
  const startDate = RatePresenter.startDate(rate);
  const endDate = RatePresenter.endDate(rate);

  return (
    <tr>
      <td>{`${DatePresenter.humanFormattedDate(
        startDate
      )}  —  ${DatePresenter.humanFormattedDate(endDate)}`}</td>
      <td>{RatePresenter.rateReadable(rate)}</td>
      <td>{RatePresenter.stateReadable(rate)}</td>
    </tr>
  );
};

export default RateCell;

RateCell.propTypes = {
  rate: RatePresenter.shape().isRequired,
};
